// QualityLossGraph.jsx
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const QualityLossGraph = ({ data }) => {
  const modifiedData = data.map((item) => ({
    ...item,
    supplier_label: `${item.supplier_name} (${item.module_wattage})`,
  }));

  // Define chart width: base width + scale with data
  const chartWidth = Math.max(600, modifiedData.length * 100); // 100px per bar group

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center", overflowX: "auto" }}>
      <div style={{ width: "50%", minWidth: chartWidth }}>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={modifiedData} barCategoryGap={10}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="supplier_label" />
            <YAxis />
            <Tooltip />
            <Legend />

            <Bar
              dataKey="quality_loss"
              stackId="a"
              fill="#779ECB"
              name="Quality Loss (%)"
              barSize={70}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default QualityLossGraph;
